import axios from 'axios';
import { PORTAL_AXIOS_TIMEOUT, SESSION_URL } from './config';
import { checkSessionValidity, performAutoLogin } from './auth-utils';

export const portalAxios = axios.create({
  baseURL: import.meta.env.VITE_FOUNDATION_API,
  timeout: PORTAL_AXIOS_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
});

portalAxios.interceptors.response.use(
  response => response,
  async error => {
    const completeUrl = error.config?.baseURL + error.config?.url;
    const isSessionUrl = completeUrl === SESSION_URL;

    if (error.response?.status === 401) {
      let confirmLogout = true;

      if (!isSessionUrl) {
        const sessionValid = await checkSessionValidity();
        confirmLogout = !sessionValid;
      }

      if (confirmLogout) {
        performAutoLogin();
      }
    }

    return Promise.reject(error);
  }
);
